export default "__VITE_ASSET__DdUUSMvx__"